import { render, staticRenderFns } from "./SuperTableAssign.vue?vue&type=template&id=99af5a18"
import script from "./SuperTableAssign.vue?vue&type=script&lang=js"
export * from "./SuperTableAssign.vue?vue&type=script&lang=js"
import style0 from "./SuperTableAssign.vue?vue&type=style&index=0&id=99af5a18&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports